import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface CompanySettingsInterface {
  languages: {
    id: number;
    code: string;
    name: string;
  }[];
  isReady: boolean;
}

const initialState: CompanySettingsInterface = {
  languages: [
    { id: 1, code: "tr", name: "Türkçe" },
    { id: 2, code: "en", name: "İngilizce" },
  ],
  isReady: false,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    setSettings: (
      state,
      { payload }: PayloadAction<CompanySettingsInterface>
    ) => {
      state = payload;
      state.isReady = true;

      return state;
    },
    setWebsiteReady: (state: any) => {
      state.isReady = true;
      return state;
    },
    setLanguages: (
      state,
      { payload }: PayloadAction<CompanySettingsInterface['languages']>
    ) => {
      state.languages = payload;
      return state;
    },
  },
});

export const { setSettings, setWebsiteReady, setLanguages } = settingsSlice.actions;

export default settingsSlice.reducer;
